import { IIndustry } from 'core/interface/companies';

export const isIndustryObject = (value: unknown): value is IIndustry => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const industry = value as { id?: unknown; name?: unknown };
  return (
    Number.isFinite(Number(industry.id)) && typeof industry.name === 'string'
  );
};

export const normalizeIndustry = (
  industry: unknown,
  catalog?: IIndustry[] | null
): IIndustry | null => {
  if (industry == null || industry === '') {
    return null;
  }

  if (isIndustryObject(industry)) {
    const id = Number(industry.id);
    const name =
      industry.name ||
      catalog?.find((item) => String(item.id) === String(id))?.name ||
      '';
    return { id, name };
  }

  const matched = catalog?.find(
    (item) => String(item.id) === String(industry)
  );
  if (matched) {
    return { id: matched.id, name: matched.name };
  }

  return null;
};

export const getIndustryDisplayName = (industry: unknown): string => {
  if (isIndustryObject(industry)) {
    return industry.name;
  }
  return typeof industry === 'string' ? industry : '';
};

/** Resolve a catalog industry by display name for form submit payloads. */
export const resolveIndustryByName = (
  name: string | undefined | null,
  catalog?: IIndustry[] | null
): IIndustry | null => {
  if (!name) return null;
  const matched = catalog?.find((item) => item.name === name);
  if (matched) {
    return { id: matched.id, name: matched.name };
  }
  return null;
};
